import { StatsResource } from '@witkac/kartamiejska-resources';
import moment from 'moment';

import { AbstractModule } from './abstract.module';

export class StatsModule extends AbstractModule<StatsResource> {
  constructor() {
    super(new StatsResource());
  }

  public state = {
    cardUsages: {},
    benefitsValue: {},
    partnersCreated: {},
    activatedCards: {},
    unconfirmedProfiles: undefined,
    readyCards: undefined
  };

  public actions = {
    /**
     * Pobiera dzienne użycie kart
     *
     * @param context context
     * @param partnerId identyfikator partnera
     */
    getCardUsages: async (context: any, partnerId?: number) => {
      const { today, inPast } = this.getDates();
      const stats = await this.resource.cardUsages(inPast, today, 'YYYY-MM-DD', partnerId as number);
      context.commit('saveCardUsages', stats);
    },
    /**
     * Pobiera dzienne wartości użytych usług
     *
     * @param context context
     * @param partnerId identyfikator partnera
     */
    getBenefitsValue: async (context: any, partnerId?: number) => {
      const { today, inPast } = this.getDates();
      const stats = await this.resource.benefitValues(inPast, today, 'YYYY-MM-DD', partnerId as number);
      context.commit('saveBenefitsValue', stats);
    },
    /**
     * Pobiera dzienną liczbę utworzonych partnerów
     *
     * @param context context
     */
    getPartnersCreated: async (context: any) => {
      const { today, inPast } = this.getDates();
      const stats = await this.resource.partnersCreated(inPast, today, 'YYYY-MM-DD');
      context.commit('savePartnersCreated', stats);
    },
    /**
     * Pobiera dzienną liczbę aktywowanych kart
     *
     * @param context context
     */
    getActivatedCards: async (context: any) => {
      const { today, inPast } = this.getLastWeekDates();
      const stats = await this.resource.activatedCards(inPast, today, 'YYYY-MM-DD');
      context.commit('saveActivatedCards', stats);
    },
    /**
     * Pobiera liczbę profili oczekujących na potwierdzenie
     *
     * @param context context
     */
    getUnconfirmedProfiles: async (context: any) => {
      const stat = await this.resource.unconfirmedProfiles();
      context.commit('saveUnconfirmedProfiles', stat);
    },
    /**
     * Pobiera liczbę kart oczekujących na wydanie
     *
     * @param context context
     */
    getReadyCards: async (context: any) => {
      const stat = await this.resource.readyCards();
      context.commit('saveReadyCards', stat);
    }
  };

  public mutations = {
    /**
     * Zapisuje dzienne użycie kart
     *
     * @param localState stan lokalny
     * @param stats obiekt ze statystykami
     */
    saveCardUsages: (localState: any, stats: any) => (localState.cardUsages = stats),
    /**
     * Zapisuje dzienne wartości użytych usług
     *
     * @param localState stan lokalny
     * @param stats obiekt ze statystykami
     */
    saveBenefitsValue: (localState: any, stats: any) => (localState.benefitsValue = stats),
    /**
     * Zapisuje dzienną liczbę utworzonych partnerów
     *
     * @param localState stan lokalny
     * @param stats obiekt ze statystykami
     */
    savePartnersCreated: (localState: any, stats: any) => (localState.partnersCreated = stats),
    /**
     * Zapisuje dzienną liczbę aktywowanych kart
     *
     * @param localState stan lokalny
     * @param stats obiekt ze statystykami
     */
    saveActivatedCards: (localState: any, stats: any) => (localState.activatedCards = stats),
    /**
     * Zapisuje liczbę profili oczekujących na potwierdzenie
     *
     * @param localState stan lokalny
     * @param stat liczba profili
     */
    saveUnconfirmedProfiles: (localState: any, stat: any) => (localState.unconfirmedProfiles = stat),
    /**
     * Zapisuje liczbę kart oczekujących na wydanie
     *
     * @param localState stan lokalny
     * @param stat liczba kart
     */
    saveReadyCards: (localState: any, stat: any) => (localState.readyCards = stat)
  };

  private getDates(): { today: Date; inPast: Date } {
    const today = moment().endOf('day').toDate();
    const monthAgo = moment(today).startOf('day').subtract(1, 'month').toDate();
    return { today, inPast: monthAgo };
  }

  private getLastWeekDates(): { today: Date; inPast: Date } {
    const today = moment().endOf('day').toDate();
    const weekAgo = moment(today).startOf('day').subtract(1, 'week').toDate();
    return { today, inPast: weekAgo };
  }
}

export default new StatsModule();
